module.exports = "<h2>{{pageTitle}}</h2>\n<div>\n       this is the License and Agreament page\n</div>\n\n"